import SectionHeading from '@/components/base/SectionHeading';
import { trendTags, updateRhythm } from '@/mocks/home';

const tagStyle = (count: number) => {
  if (count >= 900) return 'bg-primary-500 text-background-50 border-primary-500 text-sm md:text-base px-4 py-2';
  if (count >= 500) return 'bg-background-100 text-foreground-800 border-background-300 text-xs md:text-sm px-3.5 py-1.5';
  return 'bg-background-50 text-foreground-600 border-background-200 text-xs px-3 py-1.5';
};

export default function TrendTags() {
  return (
    <section id="tags" className="w-full bg-background-50 py-14 md:py-20 px-4 md:px-8">
      <div className="w-full max-w-[1180px] mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-10">
          <div className="lg:col-span-3">
            <SectionHeading
              eyebrow="Trend Tags"
              icon="ri-price-tag-3-line"
              title="趋势标签：最近被反复提起的关键词"
              desc="标签按近 7 天的检索与讨论热度排布，字号越大代表讨论越集中。点开标签即可跳转到对应板块的索引列表。"
            />
            <div className="flex flex-wrap items-center gap-2 md:gap-3">
              {trendTags.map((tag) => (
                <a
                  key={tag.id}
                  href="#board-index"
                  className={`inline-flex items-center gap-2 rounded-full border transition-colors cursor-pointer whitespace-nowrap hover:border-primary-400 ${tagStyle(
                    tag.count,
                  )}`}
                >
                  <span>{tag.name}</span>
                  <span className="opacity-70">{tag.count}</span>
                </a>
              ))}
            </div>

            <div className="mt-8 rounded-lg border border-background-200 bg-background-100 p-4 md:p-5 flex flex-col sm:flex-row sm:items-center gap-4 justify-between">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-800">
                  <i className="ri-magic-line text-lg"></i>
                </span>
                <p className="text-xs md:text-sm text-foreground-700 leading-relaxed">
                  找不到想看的板块？把关键词留在这里，编辑组会按你给的线索补充索引。
                </p>
              </div>
              <button
                type="button"
                className="h-10 px-5 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors cursor-pointer whitespace-nowrap shrink-0"
              >
                提交关键词
              </button>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              <div className="flex items-center gap-2 mb-1">
                <span className="w-6 h-6 flex items-center justify-center rounded-md bg-accent-100 text-accent-700">
                  <i className="ri-timer-flash-line text-sm"></i>
                </span>
                <span className="text-xs tracking-[0.2em] text-accent-700 uppercase">Update Rhythm</span>
              </div>
              <h3 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mt-3">
                板块更新节奏
              </h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">
                全站每天四个固定更新窗口，热门事件板块会在窗口之外随时加更。
              </p>

              <ul className="mt-6 flex flex-col">
                {updateRhythm.map((item, index) => (
                  <li key={item.id} className="relative flex gap-4 pb-6 last:pb-0">
                    {index !== updateRhythm.length - 1 ? (
                      <span className="absolute left-[19px] top-9 bottom-0 w-px bg-background-300"></span>
                    ) : null}
                    <span className="w-10 h-10 shrink-0 flex items-center justify-center rounded-full border border-background-300 bg-background-50 font-heading text-[11px] text-foreground-700 relative z-10">
                      {item.slot}
                    </span>
                    <div className="pt-1">
                      <h4 className="text-sm md:text-base text-foreground-900 font-medium">
                        <a href="#flash" className="cursor-pointer hover:text-primary-700 transition-colors">
                          {item.label}
                        </a>
                      </h4>
                      <p className="mt-1 text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}